import withDatosPersonalesEditar from "../../hoc/withTrabajadores/withDatosPersonalesEditar"
import RegistroUsuarios from "../../view/components/RegistroUsuarios/RegistroUsuarios"

export default withDatosPersonalesEditar(RegistroUsuarios);